import { apiFactory } from "../api_factory";

export const unitsApi = apiFactory({
  path: "/api/v4/facility-units"
});
